import { useMutation } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../../../services/queryClient";

export const useAdminSendConversationsMutation = ({
  id,
  setMessageInput,
}: {
  id: string;
  setMessageInput: any;
}) => {
  const token = localStorage.getItem("W2ST_ADMIN_TOKEN");

  return useMutation(
    (payload: { message: string; sender: string; type: string }) =>
      axiosInstance
        .patch(`admins/bookings/${id}/send-message`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([
          "getInifiniteConversationAdmin",
          "getConversationsQueryTutor",
          "getConversationsQueryStudent",
        ]);
        setMessageInput("");
      },
      onError: (error: any) => {
        message.error(
          error?.response?.data?.message || "Failed... Please try again."
        );
      },
    }
  );
};
